<style>
    .holder {
        padding: 20px;
        max-width: 400px;
    }

    input {
        margin-top: 5px;
        width: 100%;
    }

    .input-holder {
        margin-bottom: 10px;
    }
</style>

<script>
    import * as Common from '../Common.js'

    let areaCreationRequest = {
        area : {
            name: "",
            country: "",
            twitter_username: "",
            first_latitude: 0,
            first_longitude: 0,
            second_latitude: 0,
            second_longitude: 0
        },
        requestor_email :  ""
    }

    function submit() {
        alert("Submitting new area to system...")
        areaCreationRequest.area.first_latitude = Number(areaCreationRequest.area.first_latitude)
        areaCreationRequest.area.first_longitude = Number(areaCreationRequest.area.first_longitude)
        areaCreationRequest.area.second_latitude = Number(areaCreationRequest.area.second_latitude)
        areaCreationRequest.area.second_longitude = Number(areaCreationRequest.area.second_longitude)
        console.log(areaCreationRequest)
        Common.postData('area', areaCreationRequest)
        .then(r => {
            if(!r.ok) {
                alert("Problem submitting New Area")
            } else {
                Common.CreateNotification({body: "Created New Area."}, 1000)
            }
        })
    }
</script>


<div class="holder">
    <h1>Create An Area</h1>
    <p>
        Use the following form to create an area in the system.
    </p>
    <br>
    <br>
    <div class="input-holder">
        <strong>Requestor Email (Leave Blank if None)</strong><br>
        <input bind:value={areaCreationRequest.requestor_email}><br>
    </div>
    <div class="input-holder">
        <strong>Municipality Name</strong><br>
        <input bind:value={areaCreationRequest.area.name}><br>
    </div>
    <div class="input-holder">
        <strong>Country</strong><br>
        <input bind:value={areaCreationRequest.area.country}><br>
    </div>
    <div class="input-holder">
        <strong>Municipality Twitter Username</strong><br>
        <input bind:value={areaCreationRequest.area.twitter_username}><br>
    </div>
    <div class="input-holder">
        <strong>First Latitude</strong><br>
        <input bind:value={areaCreationRequest.area.first_latitude}><br>
    </div>
    <div class="input-holder">
        <strong>First Longitude</strong><br>
        <input bind:value={areaCreationRequest.area.first_longitude}><br>
    </div>
    <div class="input-holder">
        <strong>Second Latitude</strong><br>
        <input bind:value={areaCreationRequest.area.second_latitude}><br>
    </div>
    <div class="input-holder">
        <strong>Second Longitude</strong><br>
        <input bind:value={areaCreationRequest.area.second_longitude}><br>
    </div>
    <button on:click={() => submit()}>Submit</button>
</div>